import { render, staticRenderFns } from "./check.vue?vue&type=template&id=36147e04&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "./check.vue?vue&type=style&index=0&id=36147e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36147e04",
  null
  
)

export default component.exports